import { Button, Card, Choicebox, FormButtonRow, FormGroup, RadioGroup } from '@ksyos/design-system';
import { useNavigate, useParams } from '@ksyos/router';
import { useState } from 'react';
import type { OrderSuppliesSupplyCategory } from '@common/interfaces/orderSuppliesSupplyCategory';
import { supplyCategoriesByEpisodeCategory } from '@common/constants/supplyCategoriesByEpisodeCategory';
import { getSelectedLanguage } from '@frontend/translate';
import type { OrderSuppliesRouteParams } from '../types/orderSuppliesRouteParams';
import {
    episodeCategoryToRouteParam,
    routeParamToEpisodeCategory,
    supplyCategoryToRouteParam,
} from '../utils/orderSuppliesRouteUtils';

export function OrderSuppliesCategorySelection() {
    const navigate = useNavigate();
    const translate = getSelectedLanguage();
    const { episodeCategory: episodeCategoryParam } = useParams() as OrderSuppliesRouteParams;

    const episodeCategory = episodeCategoryParam ? routeParamToEpisodeCategory(episodeCategoryParam) : undefined;

    const [selectedSupplyCategory, setSelectedSupplyCategory] = useState<OrderSuppliesSupplyCategory | ''>('');
    const [showError, setShowError] = useState(false);

    if (!episodeCategory) {
        return null;
    }

    const currentSupplyCategory = supplyCategoriesByEpisodeCategory[episodeCategory];

    const handleSupplyCategoryChange = (selectedValue: OrderSuppliesSupplyCategory) => {
        setSelectedSupplyCategory(selectedValue);
        setShowError(false);
    };

    const handleNext = () => {
        if (!selectedSupplyCategory) {
            setShowError(true);

            return;
        }

        const episodeCategoryRouteParam = episodeCategoryToRouteParam(episodeCategory);
        const supplyCategoryRouteParam = supplyCategoryToRouteParam(selectedSupplyCategory);
        navigate(`/materialenBestellen/${episodeCategoryRouteParam}/${supplyCategoryRouteParam}`);
    };

    return (
        <Card>
            <Card.Header title={translate.orderSupplies.whatDoYouNeed} />
            <Card.Body>
                <FormGroup
                    hasErrors={showError}
                    isRequired={true}
                    layout="vertical"
                >
                    <RadioGroup
                        error={showError ? translate.validation.object_anyFilledIn : undefined}
                        layout="row"
                        name="supplyCategory"
                        onChange={(e) => {
                            handleSupplyCategoryChange(e.target.value as OrderSuppliesSupplyCategory);
                        }}
                        value={selectedSupplyCategory}
                    >
                        {Object.entries(currentSupplyCategory).map(([key, option]) => (
                            <Choicebox
                                flex={1}
                                key={key}
                                label={
                                    <>
                                        {option.image && (
                                            <img
                                                alt={option.label}
                                                src={option.image}
                                                style={{ marginBottom: '4px' }}
                                            />
                                        )}
                                        {option.label}
                                    </>
                                }
                                value={option.path}
                            />
                        ))}
                    </RadioGroup>
                </FormGroup>
                <FormButtonRow>
                    <Button
                        onClick={() => navigate(-1)}
                        variant="outline"
                    >
                        {translate.common.cancel}
                    </Button>
                    <Button onClick={handleNext}>{translate.common.proceed}</Button>
                </FormButtonRow>
            </Card.Body>
        </Card>
    );
}
